<template>
  <PopupContent class="popup-calendar">
    <MenuList
      v-if="menuItems.length > 0"
      class="popup-menu-list"
      :items="menuItems"
      :selected-item="menuSelectedItem"
      :checkbox-style="checkboxStyle"
    />
    <div v-if="calendarMode === 'days' || calendarMode === 'weeks' || calendarMode === 'months'" class="popup-calendar-content">
      <CalendarDate
        v-if="calendarMode === 'days'"
        :size="componentSize"
        :value="calendarValue"
        :range="calendarIsRange"
        :events="calendarEvents"
        :holidays="calendarHolidays"
        :disabled-dates="calendarDisabledDates"
        :start-year="calendarStartYear"
        :end-year="calendarEndYear"
        :max-range-days="calendarMaxRangeDays"
        @range-start-selected="reemitToEventBus('range-start-selected', $event)"
        @range-selected="handleSelectedDate('range-selected', $event)"
        @date-selected="handleSelectedDate('date-selected', $event)"
        @input="reemitToEventBus('input', $event)"
      />
      <CalendarWeek
        v-if="calendarMode === 'weeks'"
        :size="componentSize"
        :value="calendarValue"
        :range="calendarIsRange"
        :events="calendarEvents"
        :holidays="calendarHolidays"
        :disabled-dates="calendarDisabledDates"
        :start-year="calendarStartYear"
        :end-year="calendarEndYear"
        :max-range-weeks="calendarMaxRangeWeeks"
        @range-start-selected="reemitToEventBus('range-start-selected', $event)"
        @range-selected="handleSelectedDate('range-selected', $event)"
        @date-selected="handleSelectedDate('date-selected', $event)"
        @input="reemitToEventBus('input', $event)"
      />
      <CalendarMonth
        v-if="calendarMode === 'months'"
        :size="componentSize"
        :value="calendarValue"
        :range="calendarIsRange"
        :events="calendarEvents"
        :holidays="calendarHolidays"
        :disabled-dates="calendarDisabledDates"
        :start-year="calendarStartYear"
        :end-year="calendarEndYear"
        :max-range-months="calendarMaxRangeMonths"
        @range-start-selected="reemitToEventBus('range-start-selected', $event)"
        @range-selected="handleSelectedDate('range-selected', $event)"
        @date-selected="handleSelectedDate('date-selected', $event)"
        @input="reemitToEventBus('input', $event)"
      />
    </div>
  </PopupContent>
</template>

<script>
import PopupContent from '../popup-content';
import { eventBusReemiter } from '@/shared/lib/event-bus';
import { CalendarDate, CalendarMonth, CalendarWeek } from '@/shared/ui/calendar';
import { MenuList } from '@/shared/ui/menu-list';

export default {
  props: {
    componentSize: {
      type: String,
      default: 'small',
      validator: (value) => ['normal', 'small'].includes(value)
    },
    menuItems: {
      type: Array,
      required: true,
    },
    menuSelectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
    calendarMode: {
      type: String,
      default: 'days',
      validator: (value) => ['days', 'weeks', 'months'].includes(value),
    },
    calendarValue: {
      type: [String, Date, Object, Array],
      default: null,
    },
    calendarIsRange: {
      type: Boolean,
      default: false,
    },
    calendarEvents: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((event) => event.date),
    },
    calendarHolidays: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((holiday) => holiday.date),
    },
    calendarDisabledDates: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => {
        return item && (typeof item === 'string' || item instanceof Date || (typeof item === 'object' && item.date));
      }),
    },
    calendarStartYear: {
      type: Number,
      default: null,
      validator: (value) => value > 0,
    },
    calendarEndYear: {
      type: Number,
      default: null,
      validator: (value) => value > 0,
    },
    calendarMaxRangeDays: {
      type: Number,
      default: null,
      validator: (value) => value >= 0,
    },
    calendarMaxRangeWeeks: {
      type: Number,
      default: null,
      validator: (value) => value >= 0,
    },
    calendarMaxRangeMonths: {
      type: Number,
      default: null,
      validator: (value) => value >= 0,
    },
  },
  mixins: [ eventBusReemiter ],
  components: { PopupContent, MenuList, CalendarMonth, CalendarDate, CalendarWeek },
  methods: {
    handleSelectedDate(eventName, event) {
      this.reemitToEventBus(eventName, event);
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-menu-list {
  background-color: #ffffff;
  border: none;
  box-shadow: none;
  padding: 0;
}

.popup-calendar-content {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}
</style>
